/**
 * Standard constant for unknown/placeholder contacts
 * Used consistently across the application to identify contacts
 * that haven't been properly named or identified yet.
 */
export const UNKNOWN_CONTACT_FIRST_NAME = 'Unknown';
export const UNKNOWN_CONTACT_LAST_NAME = 'Contact';
export const UNKNOWN_CONTACT_NAME = `${UNKNOWN_CONTACT_FIRST_NAME} ${UNKNOWN_CONTACT_LAST_NAME}`;
/**
 * Placeholder values that are not a real name: our own unknown-contact
 * constants and the text an LLM returns when it finds no name. Keep out
 * words that are also real names (e.g. "Na" as a surname).
 */
const PLACEHOLDER_CONTACT_NAMES = new Set([
    UNKNOWN_CONTACT_FIRST_NAME.toLowerCase(),
    UNKNOWN_CONTACT_NAME.toLowerCase(),
    'not provided',
    'not given',
    'not mentioned',
    'not available',
    'not specified',
    'n/a',
    'null',
    'undefined',
    '-',
]);
/**
 * True when `name` is a real contact name rather than empty or a placeholder
 * such as "Unknown" or "Not provided". The check ignores case, extra spaces,
 * and surrounding brackets, quotes or dots, so "(Not provided)" and "N/A."
 * also count as placeholders. Use before treating an extracted/stored name as
 * usable.
 */
export function isKnownContactName(name) {
    const key = (name ?? '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase()
        .replace(/^[\s([{"']+|[\s)\]}"'.]+$/g, '');
    return key !== '' && !PLACEHOLDER_CONTACT_NAMES.has(key);
}
//# sourceMappingURL=contacts.js.map